import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "games-grid__count" }
const _hoisted_2 = { class: "games-grid__grid" }

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import GamesFilterMobile from "./components/games-grid/games-filter-mobile.vue";
import GamesFilterDesktop from "./components/games-grid/games-filter-desktop.vue";
import GamesEmpty from "./components/games-grid/games-grid-empty.vue";
import GamesCardGame from "./components/games-card-game.vue";
import { useGamesGrid } from "./composables/use-games-grid";


export default /*@__PURE__*/_defineComponent({
  __name: '_games-grid',
  setup(__props) {

const { loadedGames, totalCount, areGamesLoading, init, loadNextPage, filterParameters, isNextPageAvailable } =
    useGamesGrid();
const showCards = computed(() => loadedGames.value.length > 0 || isNextPageAvailable.value);
const showDesktopFilter = useBreakpoints("sm");
const skeletons = ref<InstanceType<typeof GamesCardGame>[]>([]);
const skeletonsInViewPort = ref<boolean[]>([]);
const isAnySkeletonInViewPort = computed(() => skeletonsInViewPort.value.some((s) => s));
const observer = ref<IntersectionObserver>();

watch([isAnySkeletonInViewPort, areGamesLoading], async ([isAnySkeletonInViewPortValue, areGamesLoadingValue]) => {
    if (isAnySkeletonInViewPortValue && !areGamesLoadingValue && isNextPageAvailable.value) {
        await loadNextPage();
    }
});

onMounted(async () => {
    observer.value = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const index = entry.target.getAttribute("data-index");
                const temporarySkeletons = [...skeletonsInViewPort.value];
                temporarySkeletons[index] = entry.isIntersecting;
                skeletonsInViewPort.value = [...temporarySkeletons];
            });
        },
        { threshold: 0.1, rootMargin: "0px 0px 600px 0px" }
    );

    skeletons.value.forEach((element) => {
        observer.value.observe(element.rootElement);
    });

    await init();
});

onUnmounted(() => {
    observer.value?.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#games-grid-count" }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(totalCount)), 1)
    ])),
    (_openBlock(), _createBlock(_Teleport, {
      to: "#games-grid-filters",
      defer: ""
    }, [
      (_unref(showDesktopFilter))
        ? (_openBlock(), _createBlock(GamesFilterDesktop, { key: 0 }))
        : (_openBlock(), _createBlock(GamesFilterMobile, { key: 1 }))
    ])),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(loadedGames), (game, index) => {
        return (_openBlock(), _createBlock(GamesCardGame, {
          key: `game-${index}`,
          game: game,
          variant: index === 0 ? 'double' : 'default'
        }, null, 8, ["game", "variant"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterParameters).pageSize - 1, (index) => {
        return _withDirectives((_openBlock(), _createBlock(GamesCardGame, {
          key: index,
          loading: true,
          "data-index": index - 1,
          ref_for: true,
          ref_key: "skeletons",
          ref: skeletons,
          variant: index === 0 ? 'double' : 'default'
        }, null, 8, ["data-index", "variant"])), [
          [_vShow, _unref(isNextPageAvailable)]
        ])
      }), 128))
    ], 512), [
      [_vShow, showCards.value]
    ]),
    (!showCards.value)
      ? (_openBlock(), _createBlock(GamesEmpty, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})